import actions from './actions';
import mutations from './mutations';
const state = {
  searchLoading: false,
  searchZxNews: [],
  canLoadMore: true,
  pageNum: 1,
  hotSearchKeyWords: [],
};

export default {
  namespaced: true,
  state,
  mutations: mutations,
  actions: actions,
};
